// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
 * Refresh the collection page with the provided filters.
 * 
 * @param {string} url_filters - The URL parameters for the filters.
 */
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
    
    // Créer un nouvel élément DIV pour insérer le HTML récupéré
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-grid-card-collection');
    document.querySelector('.mm-grid-card-collection').innerHTML = newSection.innerHTML;

    // Mise à jour des filtres actifs
    var activeFilters = newPageEl.querySelectorAll('.active-filters');
    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            newActiveFilter.innerHTML = activeFilter.innerHTML;
        });
    });
    
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    document.querySelector('.mm-grid-card-collection').classList.remove('mm-loading');
    
    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();
}

/*********************************************************************************************
 * Return the Shopify section ID of the collection grid.
 * 
 * @returns {string} - The section ID of the grid.
 */
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
 * Return the Shopify section ID without the 'shopify-section-' prefix.
 * 
 * @returns {string} - The shortened section ID.
 */
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
 * Perform a synchronous GET request.
 * 
 * @param {string} theUrl - The URL to request.
 * @returns {string} - The response text from the request.
 */
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
 * Check for changes in the filter inputs and submit the form if changes are detected.
 */
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    // Ajouter un listener sur chaque input pour détecter les changements
    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            fakeSubmitForm();
        });
    });
}

/*********************************************************************************************
 * Update the sort_by query parameter and reload the page with the new sorting applied.
 * 
 * @param {HTMLSelectElement} select - The select element for sorting.
 */
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

// Ajoute un listener sur le changement du select pour le tri
document.querySelector('.sort_by').addEventListener('change', function(e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});

/*********************************************************************************************
 * Serialize the form data and refresh the collection page with the filters.
 */
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
    
    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}

/*********************************************************************************************
 * Mobile filter drawer functions for screens smaller than 900px.
 */
if (window.innerWidth < 900) {
    
    /*********************************************************************************************
     * Open the mobile filters drawer.
     */
    function mmOpenFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.add('mm-open');
        document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
    }

    /*********************************************************************************************
     * Close the mobile filters drawer.
     */
    function mmCloseFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        wrapperMobile.classList.remove('mm-open');
        document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
    }

    /*********************************************************************************************
     * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
     */
    function mmCheckDrawer() {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }
}

/*********************************************************************************************
 * Toggle the accordion state for filters. 
 * Automatically opens the first three by default.
 */
function mmFiltersAccordeons() {
    const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');

	filtersHeaders.forEach(function(filtersHeader) {
		// Activer les trois premiers filtres par défaut si la largeur est supérieure ou égale à 1024 pixels
		filtersHeader.classList.remove('active'); // On enlève mm-active d'abord
		if (Array.from(filtersHeaders).indexOf(filtersHeader) < 3) {
			filtersHeader.classList.add('active');
		}
		filtersHeader.addEventListener('click', function() {
			filtersHeader.classList.toggle('active');
		});
	});
}

/*********************************************************************************************
 * Functions for handling price range sliders.
 */
const minRange = document.getElementById('min-range');
const maxRange = document.getElementById('max-range');
const sliderTrack = document.querySelector('.slider-track');
const minRangeValue = document.getElementById('min-range-value');
const maxRangeValue = document.getElementById('max-range-value');
const rangeValueSelected = document.getElementById('mm-filter-price-range-selected');

/*********************************************************************************************
 * Update the visual representation of the price range sliders and track.
 */
function updateRange() {
    const minValue = parseInt(minRange.value, 10); 
    const maxValue = parseInt(maxRange.value, 10);

    // Affiche les valeurs min et max sans virgules
    rangeValueSelected.querySelector('.price-min-value-change').innerHTML = minValue;
    rangeValueSelected.querySelector('.price-max-value-change').innerHTML = maxValue;
    
    // Calcul des pourcentages pour le fond de la track
    const minPercent = (minValue / minRange.max) * 100;
    const maxPercent = (maxValue / maxRange.max) * 100;

    // Mise à jour du fond de la track pour refléter la plage de prix sélectionnée
    sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, var(--black-900) ${minPercent}%, var(--black-900) ${maxPercent}%, #ddd ${maxPercent}%)`;
}

// Event listeners pour les sliders de prix
minRange.addEventListener('input', function() {
    if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
        minRange.value = maxRange.value - 10;
    }
    updateRange();
});

maxRange.addEventListener('input', function() {
    if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
        maxRange.value = parseInt(minRange.value) + 10;
    }
    updateRange();
});

/*********************************************************************************************
 * Save the grid preference to local storage.
 */
function saveGridPreference(isSmallGrid) {
    localStorage.setItem('mmGridPreference', isSmallGrid ? 'small' : 'large');
}

/*********************************************************************************************
 * Restore the grid preference from local storage.
 */
function restoreGridPreference() {
    const preference = localStorage.getItem('mmGridPreference');
    const grid = document.querySelector(".mm-grid-card-collection");
    const collectionProductCards = document.querySelectorAll(".mm-product-card");
    
    if (!grid) return;

    if (preference === 'small') {
        grid.classList.remove("mm-grid-card-collection-lg");
        grid.classList.add("mm-grid-card-collection-sm");
        
        if (window.matchMedia("(min-width: 1024px)").matches) {
            collectionProductCards.forEach(card => {
                card.classList.add("mm-product-card-small");
            });
        }
    } else if (preference === 'large') {
        grid.classList.remove("mm-grid-card-collection-sm");
        grid.classList.add("mm-grid-card-collection-lg");
        
        collectionProductCards.forEach(card => {
            card.classList.remove("mm-product-card-small");
        });
    }
}

/*********************************************************************************************
 * Changement de grille
 */
function mmCollectionGridSm() {
    const grid = document.querySelector(".mm-grid-card-collection");
    const collectionProductCards = document.querySelectorAll(".mm-product-card");
    
    grid.classList.remove("mm-grid-card-collection-lg");
    grid.classList.add("mm-grid-card-collection-sm");
    
    if (window.matchMedia("(min-width: 1024px)").matches) {
        collectionProductCards.forEach(card => {
            card.classList.add("mm-product-card-small");
        });
    }
	saveGridPreference(true);
}

function mmCollectionGridLg() {
    const grid = document.querySelector(".mm-grid-card-collection");
    const collectionProductCards = document.querySelectorAll(".mm-product-card");

    grid.classList.remove("mm-grid-card-collection-sm");
    grid.classList.add("mm-grid-card-collection-lg");

    collectionProductCards.forEach(card => {
        card.classList.remove("mm-product-card-small");
    });
	saveGridPreference(false);
}

/*********************************************************************************************
 * Panel de filtres
 */
function mmOpenFiltersPanel() {
    document.querySelector(`.mm-filters-panel-wrapper`).classList.remove('mm-hidden');
    document.querySelector("html").classList.add("stop-scrolling");
}

function mmCloseFiltersPanel() {
    document.querySelector('.mm-filters-panel-wrapper').classList.add('mm-hidden');
    document.querySelector("html").classList.remove("stop-scrolling");
}

/*********************************************************************************************
 * Affichage label couleur si une couleur selectionnée
 */
document.addEventListener('DOMContentLoaded', function () {
    const colorInputs = document.querySelectorAll('.filter-group-display__list-item_color input[type="checkbox"]');
    const selectedColorDiv = document.querySelector('.mm-cf-tag-selected-color');

    colorInputs.forEach(input => {
        input.addEventListener('change', function () {
            const selectedColors = Array.from(colorInputs)
                .filter(input => input.checked)
                .map(input => input.getAttribute('data_label'));

            if (selectedColors.length === 1) {
                selectedColorDiv.textContent = selectedColors[0];
            } else {
                selectedColorDiv.textContent = '';
            }
        });
    });
});

window.addEventListener("DOMContentLoaded", () => {
	checkForChanges();
    mmFiltersAccordeons();
	updateRange();
	restoreGridPreference();
});